import { Button, Result, Modal, Radio, Form } from "antd";
import { QuizOption, ParticipantOption, ParticipantOption2 } from 'assets/svg/icon';
import Confetti from 'react-confetti'
import { getDataById, getAllData, updateStatusById, updateData, createDataa, createDataUpdata } from "services/global";
import { IMAGE_BASE_URL } from 'configs/AppConfig';
import { QuestionOutlined } from '@ant-design/icons';
//import TextLoop from "react-text-loop";
import Loading from 'components/shared-components/Loading';
import React, { useEffect, useState } from "react";
import axios from "axios";
import QrReader from "react-qr-reader";
import { stringify } from "query-string";
import { useHistory } from 'react-router-dom';


const SUB_API = '/v1/registration'
const ParentRout = '/admin/dashboard'
export default function Home() {
  const history = useHistory()
  const [valid, setValid] = useState();
  const [userdata, setUserdata] = useState(null);
  const [showDialog, setDiaglog] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [precScan, setPrecScan] = useState("");
  const [selected, setSelected] = useState("environment");
  const [errorMessage, setErrorMessage] = useState(null);
  const [data, setData] = useState();
  const [showQr, setShowQr] = useState(true)
  const [Id, setId] = useState()




  const handleScan = async (scanData) => {
    console.log(`loaded data data`, scanData);
    //alert(scanData);
    if (scanData && scanData !== "" && scanData !== null) {
      console.log(`loaded >>>`, scanData);
      if (scanData.length === 26) {
        setId(JSON.parse(scanData))
        setShowQr(false)
      }

      // setPrecScan(scanData);
      //await fetchData({ qr: scanData });
    }
  };
  const handleError = (err) => {
    console.error(err);
  };

  const AddData = async () => {
    try {
      await createDataUpdata({ url: `${SUB_API}`, id: Id })
      history.push(`${ParentRout}/home`)

    } catch (error) {

    }
  }
  const init = () => {
    let x = "61b0a7d86b66d50016170a86"
    console.log(String(x));
  }

  const nextClick = () => {
    history.push(`${ParentRout}/home`)
  }

  const getFetchById = async () => {

    try {
      const { data } = await getDataById({ url: `${SUB_API}`, id: Id })

      console.log("veryyyy", data);
      setUserdata(data)
      setValid(true)

    } catch (error) {

    }
  }

  useEffect(() => {
    if (Id !== undefined) {
      getFetchById()
    }

  }, [Id])


  useEffect(() => {
    init()
  }, [data])

  return (

    <div className="home-bg">
      {showQr === true ? (
        <QrReader
          facingMode={selected}
          delay={500}
          onError={handleError}
          onScan={handleScan}
          // chooseDeviceId={()=>selected}
          style={{ width: "100%", height: "100vh" }}
          className='Qrcodee'
        />

      ) : (
        <div className="verify-page">
          {valid === true ? (
            <Result
              className="verify-result"
              status="success"
              title="Your Qr code was successfully scanned"

              extra={[
                <>
                  <p> Name: {userdata?.fName} {userdata?.lName}</p>
                  <p>Event : {userdata?.typeOfEvent}</p>
                 {userdata?.timeSlots ? (<p>Time Slot :{userdata?.timeSlots?.date} {userdata?.timeSlots?.name}</p>):''} 
                  <p></p>
                  <Button type="primary" key="console" onClick={AddData} disabled={userdata?.qrScanVerify === true}>
                    Verify
                  </Button></>,
                <Button key="buy" onClick={nextClick}>Cancel</Button>,
              ]}
            />
          ) : (
            <Result
              status="error"
              title="Not Valid QR Code "
              extra={[
                <Button type="primary" key="console" onClick={nextClick} >
                  Next
                </Button>
              ]}
            ></Result>
          )}


        </div>
      )}





      {/* <span>result : {data}</span> */}
    </div>
  );
}
